$ = require 'jquery'
Controller = require 'controller'
Util = require 'lib/util'
_ = require 'underscore'
l = require 'lib/localize'

module.exports = window.Search =
  navigateToSearch: (query, { trigger } = { trigger: false } ) ->
    Controller.navigate(
      Controller.getSearchUrl(query)
      { trigger }
    )

  inputIndex: null

  getSuggestionObjectContainingVariantOrKey: (variantOrKey) ->
    # if the key matches then cool go with it
    obj = @getKeywordMap()[variantOrKey]
    if obj?
      return { key: variantOrKey, obj }

    # maybe it's a variant?
    for key, obj of @getKeywordsWithVariants()
      if variantOrKey in obj.variants
        return { key, obj }

    {}

  findKeywords: (term) ->
    return [] if term == ""

    keywords = _.filter @getKeywordsAndVariants(), (keyword) ->
      ///^#{Util.escapeForRegex(term)}///.test(keyword)

    keywords


  findUniqueKeywords: (term) ->
    keywords = @findKeywords(term)

    uniqKeywords = _.uniq keywords, false, (keyword) =>
      @getSuggestionObjectContainingVariantOrKey(keyword).key

    return uniqKeywords

  _keywordsWith: (targetKey) ->
    _.object ([key, obj] for key, obj of @getKeywordMap() when obj.hasOwnProperty(targetKey))

  getKeywordsWithVariants: -> @_keywordsWithVariants ?= @_keywordsWith('variants')
  getKeywordsWithSearchSuggest: -> @_keywordsWithSearchSuggest ?= @_keywordsWith('suggestionsSearchModelTypes')
  getKeywords: -> @_keywords ?= _.keys(@getKeywordMap())
  getVariants: -> @_variants ?= _.flatten(keyword.variants for key, keyword of @getKeywordsWithVariants())
  getKeywordsAndVariants: -> @_keywordsAndVariants ?= @getKeywords().concat(@getVariants())

  getKeywordMap: -> @_keywordMap ?=
    # is-y stuff
    'is:archived':
      variants: ['archived', 'is:closed', 'closed']
      description: l('search.only include archived cards')
      containsRegex: /// \bis:archived\b ///

    'is:open':
      variants: ['open']
      description: l('search.only include open cards')
      containsRegex: /// \bis:open\b ///

    'is:starred':
      variants: ['is:starred']
      description: l('search.only include cards on starred boards')
      containsRegex: /// \bis:starred\b ///

    # has-y stuff
    'has:attachments':
      variants: ['attachments']
      description: l('search.only include cards with attachments')
      containsRegex: /// \bhas:attachments\b ///

    'has:cover':
      variants: ['cover']
      description: l('search.only include cards with a cover')
      containsRegex: /// \bhas:cover\b ///

    'has:description':
      variants: ['description']
      description: l('search.only include cards that have a description')
      containsRegex: /// \bhas:description\b ///

    'has:stickers':
      variants: ['stickers']
      description: l('search.only include cards that have stickers')
      containsRegex: /// \bhas:stickers\b ///

    'has:members':
      variants: ['members']
      suggestString: 'has:members'
      description: l('search.only include cards that have members assigned')
      containsRegex: /// \bhas:members\b ///

    # member stuff
    '@':
      moreInputNeeded: true
      description: l('search.cards assigned to a member')
      containsRegex: /// @\S*\b ///
      suggestionsSearchModelTypes: 'members'

    '@me':
      variants: ['me']
      description: l('search.only include cards assigned to me')
      containsRegex: /// \b@me\b ///

    'member:':
      moreInputNeeded: true
      description: l('search.cards assigned to a member')
      containsRegex: /// \bmember:\S*\b ///
      suggestionsSearchModelTypes: 'members'

    # label stuff
    'label:':
      moreInputNeeded: true
      description: l('search.cards with this label')
      containsRegex: /// \blabel:\S*\b ///

    '#':
      moreInputNeeded: true
      description: l('search.cards with this label')
      containsRegex: /// \b\#\S*\b ///

    # scope stuff
    'board:':
      moreInputNeeded: true
      description: l('search.only cards on a particular board')
      containsRegex: /// \bboard:\S*\b ///
      suggestionsSearchModelTypes: 'boards'

    'list:':
      moreInputNeeded: true
      description: l('search.cards in the list with matching text')
      containsRegex: /// \blist:\S*\b ///

    # free wordy stuff
    'name:':
      moreInputNeeded: true
      description: l('search.cards that match text in the name')
      containsRegex: /// \bname:\S*\b ///

    'comment:':
      moreInputNeeded: true
      description: l('search.cards that match text in the comment')
      containsRegex: /// \bcomment:\S*\b ///

    'checklist:':
      moreInputNeeded: true
      description: l('search.cards that match text in a checklist')
      containsRegex: /// \bchecklist:\S*\b ///

    'description:':
      moreInputNeeded: true
      description: l('search.cards that match text in the description')
      containsRegex: /// \bdescription:\S*\b ///

    # due date stuff
    'due:day':
      variants: ['day', 'today']
      description: l('search.cards due in the next 24 hours')
      containsRegex: /// \bdue:day\b ///

    'due:week':
      description: l('search.cards due in the next 7 days')
      containsRegex: /// \bdue:week\b ///

    'due:month':
      description: l('search.cards due in the next 28 days')
      containsRegex: /// \bdue:month\b ///

    'due:overdue':
      variants: ['overdue']
      description: l('search.cards that are past due')
      containsRegex: /// \bdue:overdue\b ///

    'due:incomplete':
      variants: ['notcomplete', 'incomplete', 'stilldue']
      description: l('search.cards that are incomplete')
      containsRegex: /// \bdue:incomplete\b ///

    'due:complete':
      variants: ['completed', 'complete']
      description: l('search.cards that have due dates marked complete')
      containsRegex: /// \bdue:complete\b ///

    # created stuff
    'created:day':
      description: l('search.cards created in the last 24 hours')
      containsRegex: /// \bcreated:day\b ///

    'created:week':
      description: l('search.cards created in the last 7 days')
      containsRegex: /// \bcreated:week\b ///

    'created:month':
      description: l('search.cards created in the last 28 days')
      containsRegex: /// \bcreated:month\b ///

    # edited stuff
    'edited:day':
      description: l('search.cards edited in the last 24 hours')
      containsRegex: /// \bedited:day\b ///

    'edited:week':
      description: l('search.cards edited in the last 7 days')
      containsRegex: /// \bedited:week\b ///

    'edited:month':
      description: l('search.cards edited in the last 28 days')
      containsRegex: /// \bedited:month\b ///



// WEBPACK FOOTER //
// ./app/scripts/views/search/search.coffee